import { Draggable, Map, Marker, ZoomControl } from 'pigeon-maps';
import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import CustomButton from '../../../../../../components/shared/CustomButton';
import CustomInput from '../../../../../../components/shared/CustomInput';
import { useEffect, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { useGeolocated } from 'react-geolocated';
import LocationSearchingRoundedIcon from '@mui/icons-material/LocationSearchingRounded';
import { ReactComponent as CameraLocationToMarker } from '../../../../../../assets/location-to-marker.svg';
import PinDropIcon from '@mui/icons-material/PinDrop';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import {
  changeAddress,
  changeCenter,
  changeCoordinate,
  changeMapTypeSupplier,
  changePlaceGetByName,
  fetchPlacesSearchByCoordinate,
  fetchPlacesSearchByName,
  getAllDataAddSupplier,
  submitAddresMap,
} from '../../../../../../store/supplier/addSupplier';

const SetupAddressAddSupplier = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const {
    address,
    addressFix,
    coordinateFix,
    mapInputType,
    placeGetByName,
    coordinate,
    center,
    placesSearchByName,
    placesSearchByNameLoading,
    placeGetByCoordinate,
    placeGetByCoordinateLoading,
  } = useSelector(getAllDataAddSupplier);
  const [zoom, setZoom] = useState(17);
  const [anchorByMapFix, setAnchorByMapFix] = useState([]);

  const [currentCoordinateLat, setCurrentCoordinateLat] = useState(0);
  const [currentCoordinateLong, setCurrentCoordinateLong] = useState(0);

  // ----- manual search
  const [manualSearch, setManualSearch] = useState('');
  const [manualSearchFix, setManualSearchFix] = useState('');
  const debouncedManualSearch = useRef(
    debounce((value) => {
      setManualSearchFix(value);
    }, 1000)
  ).current;

  const debouncedGetByMap = useRef(
    debounce((value) => {
      setAnchorByMapFix(value);
    }, 2000)
  ).current;

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
    });

  useEffect(() => {
    if (!manualSearchFix) {
      dispatch(fetchPlacesSearchByName('medan'));
    } else {
      dispatch(fetchPlacesSearchByName(manualSearchFix));
    }
  }, [manualSearchFix]);

  useEffect(() => {
    dispatch(
      fetchPlacesSearchByCoordinate({
        lat: anchorByMapFix[0],
        lon: anchorByMapFix[1],
      })
    );
  }, [anchorByMapFix]);

  function handleGetCurrentCoordinate() {
    if (isGeolocationAvailable) {
      setCurrentCoordinateLat(coords.latitude);
      setCurrentCoordinateLong(coords.longitude);
      dispatch(changeCoordinate([coords.latitude, coords.longitude]));
      dispatch(changeCenter([coords.latitude, coords.longitude]));
      if (mapInputType !== 'manual') {
        debouncedGetByMap([coords.latitude, coords.longitude]);
      }
    }
  }

  const handleResetZoom = () => {
    dispatch(changeCenter(coordinate));
  };

  const handleResetMarker = () => {
    dispatch(changeCoordinate(center));
    if (mapInputType !== 'manual') {
      debouncedGetByMap(center);
    }
  };

  const handleEnter = () => {
    dispatch(submitAddresMap({ address: address, coordinate: coordinate }));
    setIsOpen(false);
  };

  const [isSubmitAvailable, setIsSubmitAvailable] = useState(false);

  useEffect(() => {
    if (address) {
      if (coordinate.length !== 0) {
        return setIsSubmitAvailable(true);
      } else {
        return setIsSubmitAvailable(false);
      }
    } else {
      return setIsSubmitAvailable(false);
    }
  }, [address, coordinate]);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItem: 'center',
          gap: 1,
          p: '8px',
          borderRadius: '8px',
          bgcolor: '#F5F5F5',
        }}
      >
        <Box
          onClick={() => dispatch(changeMapTypeSupplier('manual'))}
          sx={[
            {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '270px',
              height: '44px',
              borderRadius: '8px',
              cursor: 'pointer',
            },
            mapInputType === 'manual'
              ? {
                  bgcolor: '#FFFFFF',
                }
              : {
                  bgcolor: '#F5F5F5',
                },
          ]}
        >
          <Typography
            sx={[
              mapInputType === 'manual'
                ? {
                    color: '#51B15C',
                  }
                : {
                    color: 'black',
                  },
            ]}
          >
            Manual input
          </Typography>
        </Box>
        <Box
          onClick={() => dispatch(changeMapTypeSupplier('bymap'))}
          sx={[
            {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: '#FFFFFF',
              width: '270px',
              height: '44px',
              borderRadius: '8px',
              cursor: 'pointer',
            },
            mapInputType === 'bymap'
              ? {
                  bgcolor: '#FFFFFF',
                }
              : {
                  bgcolor: '#F5F5F5',
                },
          ]}
        >
          <Typography
            sx={[
              mapInputType === 'bymap'
                ? {
                    color: '#51B15C',
                  }
                : {
                    color: 'black',
                  },
            ]}
          >
            Select by map
          </Typography>
        </Box>
      </Box>

      {/* isi */}
      <Box>
        {mapInputType === 'manual' ? (
          <Box>
            {/* //* City n distric */}
            <Box sx={{ mt: '12px' }}>
              <Typography>City & District*</Typography>
              <Autocomplete
                value={placeGetByName}
                onChange={(_, newValue) => {
                  dispatch(changePlaceGetByName(newValue));
                }}
                inputValue={manualSearch}
                onInputChange={(_, newInputValue) => {
                  setManualSearch(newInputValue);
                  debouncedManualSearch(newInputValue);
                }}
                options={placesSearchByName}
                loading={
                  placesSearchByNameLoading || manualSearch !== manualSearchFix
                }
                getOptionLabel={(option) => option.formatted}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select City"
                    sx={{ width: '100%', bgcolor: '#FAFAFA', mt: '12px' }}
                  />
                )}
              />
            </Box>
            {/* //* Address */}
            <Box sx={{ mt: '12px' }}>
              <Typography>Address*</Typography>
              <CustomInput
                value={address}
                onChange={(e) => dispatch(changeAddress(e.target.value))}
                placeholder="Enter address"
                sx={{ width: '100%', bgcolor: '#FAFAFA', mt: '12px' }}
              />
            </Box>
            <Typography sx={{ mt: '12px' }}>Pinpoint</Typography>
            {/* //* MAP */}
            <Box sx={{ position: 'relative', mt: '12px' }}>
              <Box
                sx={{
                  position: 'absolute',
                  zIndex: '+5',
                  bottom: 4,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    mb: '8px',
                    ml: '8px',
                    p: '4px',
                    borderRadius: '8px',
                  }}
                >
                  <Box
                    onClick={handleGetCurrentCoordinate}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <LocationSearchingRoundedIcon
                      sx={{
                        fontSize: '20px',
                        color: '#51B15C',
                      }}
                    />
                  </Box>
                  <Box
                    onClick={handleResetZoom}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <CameraLocationToMarker
                      style={{ fontSize: '20px', color: '#51B15C' }}
                    />
                  </Box>
                  <Box
                    onClick={handleResetMarker}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <PinDropIcon sx={{ fontSize: '20px', color: '#F64444' }} />
                  </Box>
                </Box>
              </Box>
              <Map
                height={300}
                center={center}
                zoom={zoom}
                onBoundsChanged={({ center, zoom }) => {
                  dispatch(changeCenter(center));
                  setZoom(zoom);
                }}
              >
                <ZoomControl />
                {coordinate.length !== 0 && (
                  <Draggable
                    anchor={coordinate}
                    onDragEnd={(coordinate) =>
                      dispatch(changeCoordinate(coordinate))
                    }
                  >
                    <LocationOnRoundedIcon
                      color="error"
                      sx={{ fontSize: '30px' }}
                    />
                  </Draggable>
                )}
              </Map>
            </Box>
            {/* //* Submit */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                mt: '24px',
              }}
            >
              <CustomButton
                disabled={!isSubmitAvailable || !placeGetByName}
                variant="contained"
                onClick={handleEnter}
                sx={{ width: '198px', height: '48px' }}
              >
                Enter
              </CustomButton>
            </Box>
          </Box>
        ) : (
          <Box>
            {/* //* MAP */}
            <Box sx={{ position: 'relative', mt: '12px' }}>
              <Box
                sx={{
                  position: 'absolute',
                  zIndex: '+5',
                  bottom: 4,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    mb: '8px',
                    ml: '8px',
                    p: '4px',
                    borderRadius: '8px',
                  }}
                >
                  <Box
                    onClick={handleGetCurrentCoordinate}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <LocationSearchingRoundedIcon
                      sx={{
                        fontSize: '20px',
                        color: '#51B15C',
                      }}
                    />
                  </Box>
                  <Box
                    onClick={handleResetZoom}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <CameraLocationToMarker
                      style={{ fontSize: '20px', color: '#51B15C' }}
                    />
                  </Box>
                  <Box
                    onClick={handleResetMarker}
                    sx={{
                      width: '24px',
                      height: '24px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      boxShadow: '8px',
                    }}
                  >
                    <PinDropIcon sx={{ fontSize: '20px', color: '#F64444' }} />
                  </Box>
                </Box>
              </Box>

              <Map
                height={300}
                center={center}
                zoom={zoom}
                onBoundsChanged={({ center, zoom }) => {
                  dispatch(changeCenter(center));
                  setZoom(zoom);
                }}
              >
                <ZoomControl />
                {coordinate.length !== 0 && (
                  <Draggable
                    anchor={coordinate}
                    onDragEnd={(coordinate) => {
                      dispatch(changeCoordinate(coordinate));
                      debouncedGetByMap(coordinate);
                    }}
                  >
                    <LocationOnRoundedIcon
                      color="error"
                      sx={{ fontSize: '40px' }}
                    />
                  </Draggable>
                )}
              </Map>
            </Box>
            {/* //* City n distric */}
            <Box sx={{ mt: '12px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography>City & District*</Typography>
                {coordinate !== anchorByMapFix ||
                  (placeGetByCoordinateLoading && (
                    <CircularProgress size={12} />
                  ))}
              </Box>
              <CustomInput
                placeholder="Select city"
                value={
                  placeGetByCoordinate ? placeGetByCoordinate?.formatted : ''
                }
                disabled={true}
                sx={{
                  width: '100%',
                  bgcolor: placeGetByCoordinate?.formatted
                    ? '#FAFAFA'
                    : '#E4E4E4',
                  mt: '12px',
                }}
              />
            </Box>
            {/* //* Address */}
            <Box sx={{ mt: '12px' }}>
              <Typography>Address*</Typography>
              <CustomInput
                value={address}
                onChange={(e) => dispatch(changeAddress(e.target.value))}
                placeholder="Enter address"
                sx={{ width: '100%', bgcolor: '#FAFAFA', mt: '12px' }}
              />
            </Box>
            {/* //* Submit */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                mt: '24px',
              }}
            >
              <CustomButton
                disabled={!isSubmitAvailable || !placeGetByCoordinate}
                variant="contained"
                onClick={handleEnter}
                sx={{ width: '198px', height: '48px' }}
              >
                Enter
              </CustomButton>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default SetupAddressAddSupplier;
